import axios from 'axios'
import { API_URL } from '../env.json'

const AxiosInstance = axios.create({
  baseURL:API_URL,
})

export default AxiosInstance
